import Vue from 'vue'

/**
 * directive: ステーテタスに合わせて文言を表示
 * @param { string } type - 使用用途
 * <span v-status-format="manage">4</span>
 * => プロフィール入力済み
 */

const statusLabels = {
  '0': { default: '', admin: '', manage: '' },
  '1': { default: '応募', admin: '応募', manage: '応募' },
  '2': {
    default: 'メール送信(認証)済み',
    admin: 'メール送信(認証)済み',
    manage: 'メール送信(認証)済み'
  },
  '3': { default: '支払い済み', admin: '支払い済み', manage: '支払い済み' },
  '4': {
    default: '動画アップロード完了',
    admin: '動画アップロード完了',
    manage: '動画アップロード完了'
  },
  '5': {
    default: '',
    admin: '',
    manage: ''
  },
  '6': {
    default: 'コメント登録完了',
    admin: 'コメント登録完了',
    manage: 'コメント登録完了'
  },
  '7': { default: '', admin: '', manage: '' },
  '8': { default: '', admin: '', manage: '' },
  '9': { default: 'キャンセル', admin: 'キャンセル', manage: 'キャンセル' }
}

Vue.directive('status-format', {
  bind(el, binding) {
    const value = Number(el.textContent) || 0
    const type = statusLabels[value].hasOwnProperty(binding.value)
      ? binding.value
      : 'default'
    if (statusLabels[value]) {
      Object.assign(el, { textContent: statusLabels[value][type] })
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/statusFormat.js